"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateApy = exports.computeDelegatorRewardPercentage = exports.convertEpochYieldToApy = void 0;
const constants_1 = require("../constants");
const convertEpochYieldToApy = (epochYield) => {
    return (Number(epochYield) * 52 * 100) / constants_1.FRACTION_PRECISION;
};
exports.convertEpochYieldToApy = convertEpochYieldToApy;
const computeDelegatorRewardPercentage = (delegationFee) => {
    return 1 - Number(delegationFee) / constants_1.FRACTION_PRECISION;
};
exports.computeDelegatorRewardPercentage = computeDelegatorRewardPercentage;
const calculateApy = (options) => {
    const { selfStake, poolCapacity, yieldRate, isSelf } = options;
    const eligibleSelfStake = selfStake > poolCapacity ? poolCapacity : selfStake;
    if (poolCapacity === 0n) {
        return 0;
    }
    const apyPercentage = (0, exports.convertEpochYieldToApy)(yieldRate);
    if (isSelf) {
        if (selfStake === 0n) {
            return apyPercentage;
        }
        return (apyPercentage * Number(eligibleSelfStake)) / Number(selfStake);
    }
    const { poolUtilization } = options;
    const delegatorPercentage = (0, exports.computeDelegatorRewardPercentage)(options.delegationFee);
    const delegatorPoolUtilization = poolUtilization - selfStake;
    const delegatorPoolCapacity = poolCapacity - eligibleSelfStake;
    const eligibleStake = delegatorPoolUtilization > delegatorPoolCapacity
        ? delegatorPoolCapacity
        : delegatorPoolUtilization;
    if (poolUtilization === selfStake) {
        return ((selfStake >= poolCapacity ? 0 : apyPercentage) * delegatorPercentage);
    }
    return ((apyPercentage * delegatorPercentage * Number(eligibleStake)) /
        Number(delegatorPoolUtilization));
};
exports.calculateApy = calculateApy;
